import { createSlice } from "@reduxjs/toolkit";

const catalogSlice = createSlice({
  name: "catalog",
  initialState: {
    catalogDetails: {},
    loading: false,
    error: null,
  },
  reducers: {
    fetchCatalogDetailRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchCatalogDetailSuccess: (state, action) => {
      const { entryId, data } = action.payload;
      state.loading = false;
      // Normalize key to string so modal and detail page read the same entry (source.entry_id may be string or number)
      state.catalogDetails[String(entryId)] = data;
      state.error = null;
    },
    fetchCatalogDetailFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearCatalogDetail: (state, action) => {
      const entryId = action.payload;
      if (entryId) {
        delete state.catalogDetails[entryId];
      } else {
        state.catalogDetails = {};
      }
    },
  },
});

export const {
  fetchCatalogDetailRequest,
  fetchCatalogDetailSuccess,
  fetchCatalogDetailFailure,
  clearCatalogDetail,
} = catalogSlice.actions;

export default catalogSlice.reducer;

